import { Injectable, Inject, DOCUMENT } from '@angular/core';

import { Router } from '@angular/router';
import { absoluteUrl, canonicalPath } from './seo.constants';

@Injectable({
   providedIn: 'root'
})

export class CanonicalService {
   constructor(@Inject(DOCUMENT) private dom: Document,
   private router : Router) { }

  /**
   * Points <link rel="canonical"> at the clean URL of `path` (default: the
   * current route): production origin, no query string (UTM etc.), no
   * fragment, no trailing slash. Returns the URL it set.
   */
  createCanonicalURL(path?: string): string {
    const canonicalUrl = absoluteUrl(canonicalPath(path ?? this.router.url));
    const head = this.dom.head;
    const links = Array.from(head.querySelectorAll(`link[rel='canonical']`));
    links.slice(1).forEach(l => l.remove());
    let element = links[0] as HTMLLinkElement | undefined;
    if (!element) {
      element = this.dom.createElement('link');
      element.setAttribute('rel', 'canonical');
      head.appendChild(element);
    }
    element.setAttribute('href', canonicalUrl);
    return canonicalUrl;
  }
}
